import setFilterQuery from "@bevco/Store/Handlers/Blog/SetFilterQuery";
import { CustomState } from "@bevco/Store/Reducers";
import { initialBlogState } from "@bevco/Store/State/Blog/BlogListState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import convertToNumberIfString from "@insite/mobius/utilities/convertToNumberIfString";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (customState: CustomState) => {
    const pagination = customState.blogList.pagination;

    return { pagination };
};

const mapDispatchToProps = {
    setFilterQuery,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface BlogListResultsPerPageStyles {
    wrapper?: InjectableCss;
    selectPerPage?: SelectPresentationProps;
}

export const blogListResultsPerPageStyles: BlogListResultsPerPageStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            min-height: 40px;
        `,
    },
    selectPerPage: {
        labelProps: {
            css: css`
                width: auto;
                padding-right: 10px;
            `,
        },
        cssOverrides: {
            formField: css`
                width: auto;
            `,
            formInputWrapper: css`
                width: auto;
                margin: 0;
            `,
            inputSelect: css`
                width: 80px;
            `,
        },
    },
};

const styles = blogListResultsPerPageStyles;

const BlogListResultsPerPage: FC<Props> = ({ pagination, setFilterQuery }) => {
    if (!pagination?.pageSizeOptions.length || !pagination?.totalItemCount) {
        return null;
    }

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const pageSize = parseInt(event.currentTarget.value, 10);
        setFilterQuery({
            parameters: {
                page: initialBlogState.parameters.page,
                pageSize,
            },
        });
    };

    const resultsPerPageOptions = pagination.pageSizeOptions;
    const resultsPerPage = convertToNumberIfString(pagination.pageSize);

    return (
        <StyledWrapper {...styles.wrapper}>
            <Select
                {...styles.selectPerPage}
                onChange={changeResultsPerPage}
                label={translate("Results Per Page")}
                labelPosition="left"
                value={resultsPerPage}
                data-test-selector="pagination_resultsPerPage"
            >
                {resultsPerPageOptions.map((n: string | number) => (
                    <option key={n} value={n}>
                        {n}
                    </option>
                ))}
            </Select>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(BlogListResultsPerPage as any) as any,
    definition: {
        displayName: "Category List Results per page",
        group: "Verndale Box - Blog" as any,
        icon: "hashtag",
        allowedContexts: ["BlogCategoryPage" as any],
    },
};

export default widgetModule;
